module.exports = __webpack_public_path__ + "h5/img/lvka_bg.740e85d7.png";